import { BackArrowIcon } from "@/assets/icons/admin";
import { Button, Input } from "@nextui-org/react";
import { ProviderShareData } from ".";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { toast } from "react-toastify";

interface EditProviderRateProps {
  data: ProviderShareData | undefined;
  onClose: () => void;
}

type Inputs = {
  id: number;
  provider: string;
  category: string;
  rates: number[];
};

const EditProviderRate = (props: EditProviderRateProps) => {
  const [rates, setRates] = useState<number[]>(props?.data?.rates || []);
  const { register, handleSubmit, setValue } = useForm<Inputs>({
    defaultValues: {
      id: props?.data?.id,
      provider: props?.data?.provider,
      category: props?.data?.category,
      rates: props?.data?.rates,
    },
  });

  const updateRates = (index: number, value: number) => {
    const newRates = [...rates];
    newRates[index] = parseFloat(value.toString()) / 100;
    setValue("rates", newRates);
    setRates(newRates);
  };

  const onSubmit = async () => {
    await fetch(`${import.meta.env.VITE_GGR_API_URI}/config/rates`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: props?.data?.id,
        provider: props?.data?.provider,
        category: props?.data?.category,
        rates: rates,
      }),
    })
      .then(() => {
        props.onClose();
      })
      .catch((err) => {
        toast.error("Failed to update provider rates");
        console.error(err);
      });
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="font-ubuntu mb-3 w-full text-center text-2xl font-semibold text-white sm:float-left sm:mb-3">
          <span>
            <Button
              isIconOnly
              className="transparent-bg float-left ml-[-11px] h-auto w-auto"
              onClick={props.onClose}
            >
              <BackArrowIcon />
            </Button>
            <p className="text-sm sm:float-left sm:text-lg md:text-lg lg:text-lg">
              Edit Provider Rates
            </p>
          </span>
        </div>
        <div className="flex w-full flex-row gap-8">
          <div className="flex w-full flex-col ">
            <label
              htmlFor="providerName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Provider
            </label>
            <div></div>
            <Input
              {...register("provider")}
              readOnly={true}
              name="provider"
              defaultValue={props?.data?.provider}
              className={`relative w-full !cursor-text rounded-md border border-solid`}
              classNames={{
                inputWrapper: ["!cursor-text", "bg-white-5", "text-sm"],
              }}
            ></Input>
          </div>
          <div className="flex w-full flex-col ">
            <label
              htmlFor="category"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Category
            </label>
            <div></div>
            <Input
              {...register("category")}
              readOnly={true}
              name="category"
              defaultValue={props?.data?.category}
              className={`w-full !cursor-text rounded-md border border-solid`}
              classNames={{
                inputWrapper: ["!cursor-text", "bg-white-5", "text-sm"],
              }}
            ></Input>
          </div>
        </div>
        <div className="mt-4 grid grid-cols-5 gap-4">
          {props?.data?.rates.map((rate, index) => (
            <div className="relative flex w-full flex-col ">
              <label
                htmlFor="category"
                className="field-label mb-2 block text-sm font-normal text-white"
              >
                {(100000 * index + 1).toLocaleString() +
                  "-" +
                  (100000 * (index + 1)).toLocaleString()}
              </label>
              <div></div>
              <Input
                onChange={(e) => {
                  updateRates(index, e.target.value as any);
                }}
                type="number"
                defaultValue={(
                  (props?.data?.rates[index] || 0) * 100
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
                className={`w-full !cursor-text rounded-md border border-solid`}
                classNames={{
                  inputWrapper: ["!cursor-text", "bg-white-5", "text-sm"],
                }}
              ></Input>
              <p className="absolute right-2 top-9">%</p>
            </div>
          ))}
        </div>
        <div className="flex w-full flex-col gap-6">
          <div className="sm:flex sm:flex-row">
            <div className="mb-10 mt-5 w-fit basis-full sm:basis-1/2">
              <div className="float-right">
                <Button
                  className="admin-common-button-gradient font-ubuntu w-full rounded-md pl-32 pr-32 text-base font-bold sm:pl-20 sm:pr-20"
                  type="submit"
                >
                  <span className="">Save Changes</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EditProviderRate;
